export enum EXSignInStages {
  REQUEST_REDIRECT = 'request_redirect',
  REQUEST_OAUTH_TOKEN = 'request_oauth_token',
  REQUEST_JWT = 'request_jwt',
}
